import { IComponentController } from 'angular';
import {  IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';

interface IPageMC2050 extends IComponentController {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Mc2050Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass
) {
    const vm: IPageMC2050 = this;

    vm.multiOccurrenceOptions = {
        fonctions:{
            rechercheCollapsable: false
        },
        colonnesVisibles: [
            { nom: 'imp', largeur: 200 },
            { nom: 'dovmntdepnet', largeur: 125 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('imp', { readonly: true }),
            new FormulaireItem('dovmntdepnet')
        ])
    };


}
